module.exports = __webpack_public_path__ + "img/8coin.9c53fbea.png";